import Kpi from 'types/Kpi';

import { compareMonths, getCurrentMonth } from '../../utils';
import { KpiType } from './types';

export const getKpiType = (kpi: Kpi) => {
    if (kpi.items.length > 0) {
        return KpiType.PA;
    } else if (kpi.type === 'compulsory') {
        return KpiType.Compulsory;
    } else {
        return KpiType.Additional;
    }
};

export const compareKpis = (kpi1: Kpi, kpi2: Kpi) => {
    const kpi1Type = getKpiType(kpi1);
    const kpi2Type = getKpiType(kpi2);

    if (kpi1Type === kpi2Type) {
        if (kpi1.items.length && kpi2.items.length) {
            return kpi1.items[0].id - kpi2.items[0].id;
        } else {
            return kpi1.id - kpi2.id;
        }
    }

    return kpi1Type - kpi2Type;
};

export const formatSavedCo2 = (kpi: Kpi) => {
    if (kpi.co2Saved === null) {
        return 'n.d.';
    }

    const lastUpdateMonth = {
        month: kpi.co2SavedUpdatedAt[0],
        year: kpi.co2SavedUpdatedAt[1]
    };

    let formattedCo2Saved = (!kpi.co2Saved ? kpi.co2Saved : (kpi.co2Saved * -1)).toFixed(2);

    if (compareMonths(lastUpdateMonth, getCurrentMonth()) < 0) {
        formattedCo2Saved += ' (al mese ' + kpi.co2SavedUpdatedAt[0] + '/' + kpi.co2SavedUpdatedAt[1] + ')';
    }

    return formattedCo2Saved;
};